
import { Component, Vue, Watch } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import MobileSectionStrip from "@/components/Common/Web/MobileSectionStrip.vue";
import menuService from "@/services/menu.service";

@Component({
  components: {
    MobileSectionStrip
  }
})
export default class Telefonos extends Vue {
  private menu: any = [];
  private menuLateral: any = [];
  private unidades: any = null;
  private unidadesMenu: any = null;
  private busqueda: any = null;
  private text: string = "";
  private selected: any = null;
  private verContactos: boolean = false;

  @Watch("text")
  private watchText() {
    this.buscar();
  }
  private mounted() {
    this.setMenu();
    this.getTelefonos();
  }

  private async setMenu() {
    this.menu = await menuService.getMenu();
    for (let i = 0; i < this.menu.length; i++) {
      if (this.getSubMenu(this.menu[i], "oficinas-y-telefonos-municipales")) {
        this.menuLateral = this.menu[i].sub_menu || [];
        break;
      }
    }
  }

  private getSubMenu(element: any, nombreWeb: string) {
    if (element.nombre_web == nombreWeb) return true;
    if (element.sub_menu && element.sub_menu.length > 0) {
      for (let i = 0; i < element.sub_menu.length; i++) {
        if (this.getSubMenu(element.sub_menu[i], nombreWeb)) return true;
      }
    }
    return false;
  }

  private getTelefonos() {
    this.$axios
      .get("telefonos")
      .then(res => {
        this.unidades = res.data;
        this.busqueda = res.data;
        this.unidadesMenu = [];
        for (let i = 0; i < res.data.length; i++) {
          const element = res.data[i];
          this.unidadesMenu.push({
            nombre: element.nombre,
            id: element.id
          });
        }
        this.selected = this.busqueda[0];
      })
      .catch((err: any) => {
        this.routerGo("Home");
        this.unidades = null;
      });
  }

  private getStyle(id: any) {
    if (id == this.selected.id) {
      return "border-bottom: 1px solid grey;background-color:#f1f1f1;";
    }
    return "border-bottom: 1px solid grey;";
  }

  private getContactName(info: any) {
    if (info && info.nombre && String(info.nombre).trim() !== "") {
      return info.nombre;
    }

    return "No informado";
  }

  private getContactInitial(info: any) {
    return this.getContactName(info)
      .charAt(0)
      .toUpperCase();
  }

  private getContactField(info: any, field: string) {
    if (info && info[field] && String(info[field]).trim() !== "") {
      return info[field];
    }

    if (
      this.selected &&
      this.selected[field] &&
      String(this.selected[field]).trim() !== ""
    ) {
      return this.selected[field];
    }

    return "No informado";
  }

  private getUnitInfoRows(unit: any) {
    return [
      {
        label: "Director/Responsable",
        value: unit.responsable,
        icon: "person"
      },
      { label: "Dirección", value: unit.direccion, icon: "place" },
      { label: "Correo", value: unit.email, icon: "email" },
      { label: "Horario", value: unit.horario, icon: "schedule" }
    ].filter(row => row.value && String(row.value).trim() !== "");
  }

  private getContactRows(info: any) {
    return [
      { label: "Teléfono", value: info.telefono, icon: "phone" },
      { label: "Correo", value: info.email, icon: "email" },
      {
        label: "Dirección",
        value: this.getContactField(info, "direccion"),
        icon: "place"
      },
      {
        label: "Horario",
        value: this.getContactField(info, "horario"),
        icon: "schedule"
      }
    ].filter(row => row.value && String(row.value).trim() !== "");
  }

  @Debounce(500)
  private buscar() {
    if (this.text.trim().length > 1) {
      let result: any = [];
      for (let i = 0; i < this.unidades.length; i++) {
        let unidad = this.unidades[i];
        let contiene = false;
        if (unidad.nombre.toUpperCase().indexOf(this.text.toUpperCase()) >= 0) {
          contiene = true;
        } else if (
          unidad.direccion &&
          unidad.direccion.toUpperCase().indexOf(this.text.toUpperCase()) >= 0
        ) {
          contiene = true;
        } else if (
          unidad.email &&
          unidad.email.toUpperCase().indexOf(this.text.toUpperCase()) >= 0
        ) {
          contiene = true;
        } else if (
          unidad.horario &&
          unidad.horario.toUpperCase().indexOf(this.text.toUpperCase()) >= 0
        ) {
          contiene = true;
        } else if (
          unidad.responsable &&
          unidad.responsable.toUpperCase().indexOf(this.text.toUpperCase()) >= 0
        ) {
          contiene = true;
        } else {
          let contactosFiltrados: any = [];
          for (let j = 0; j < unidad.contacto.length; j++) {
            const contacto = unidad.contacto[j];
            if (
              contacto.nombre &&
              contacto.nombre.toUpperCase().indexOf(this.text.toUpperCase()) >=
                0
            ) {
              contactosFiltrados.push(contacto);
              contiene = true;
              continue;
            } else if (
              contacto.telefono &&
              contacto.telefono
                .toUpperCase()
                .indexOf(this.text.toUpperCase()) >= 0
            ) {
              contactosFiltrados.push(contacto);
              contiene = true;
              continue;
            } else if (
              contacto.email &&
              contacto.email.toUpperCase().indexOf(this.text.toUpperCase()) >= 0
            ) {
              contactosFiltrados.push(contacto);
              contiene = true;
              continue;
            } else if (
              contacto.direccion &&
              contacto.direccion
                .toUpperCase()
                .indexOf(this.text.toUpperCase()) >= 0
            ) {
              contactosFiltrados.push(contacto);
              contiene = true;
              continue;
            } else if (
              contacto.horario &&
              contacto.horario.toUpperCase().indexOf(this.text.toUpperCase()) >=
                0
            ) {
              contactosFiltrados.push(contacto);
              contiene = true;
              continue;
            }
          }
          if (contactosFiltrados.length > 0) {
            unidad.contacto = contactosFiltrados;
          } else {
            unidad.contacto = this.unidades[i].contacto;
          }
        }
        if (contiene) {
          result.push(unidad);
        }
      }
      if (result.length > 0) {
        this.busqueda = result;
        this.selected = this.busqueda[0];
      } else {
        this.busqueda = null;
      }
    } else if (this.text.trim() == "") {
      this.getTelefonos();
    }
  }

  private mostrarDatos(id: any) {
    for (let i = 0; i < this.busqueda.length; i++) {
      const element = this.busqueda[i];
      if (element.id == id) {
        this.selected = element;
        break;
      }
    }
    if (this.$q.screen.xs || this.$q.screen.sm) {
      this.verContactos = true;
    }
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private irMenuItem(item: any) {
    if (item.tipo == 1 || item.tipo == 2) {
      this.irPagina(item.nombre_web);
    } else if (item.tipo == 0) {
      this.toLink(item.url, item.blank);
    }
  }

  private irPagina(nombreWeb: any) {
    if (nombreWeb == "oficinas-y-telefonos-municipales") {
      this.routerGo("Telefonos");
    } else if (nombreWeb == "centros-de-atencion-municipal-cam") {
      this.routerGo("Cam");
    } else {
      this.$router.push({ name: "Pagina", params: { nombre: nombreWeb } });
    }
  }

  private toLink(url: any, blank: any) {
    if (url && url != "") {
      window.open(url, blank == 1 || blank == "_blank" ? "_blank" : "_self");
    }
  }
}
